import React from "react";
import axios from "axios";

export default function DownloadButton({ filename }) {
    const downloadResume = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:5001'}/api/resume/download`, { filename }, { responseType: "blob" });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "resume.docx");
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error("Failed to download resume:", error);
        }
    };

    return <button onClick={downloadResume}>Download DOCX</button>;
}